import React from "react";
import { MedicationGroup } from "components";
import { useCurrentCase } from "duck";
import { CreateDefib } from "./components";
import { useDeleteDefib, useUpdateDefib } from "./duck";

const DefibMedications: React.FC = () => {
  const defibMedications = useCurrentCase(
    ({ data }) => data.client.patient.defibMedications
  );
  const update = useUpdateDefib();
  const deleteMedication = useDeleteDefib();

  return (
    <MedicationGroup.Provider update={update}>
      <MedicationGroup
        groupName="Defib. Monophasic"
        medications={defibMedications}
        create={<CreateDefib />}
        onDelete={deleteMedication}
        doseUnit="J"
        medicationType="defib"
        expandedCards={false}
      />
    </MedicationGroup.Provider>
  );
};

export default DefibMedications;
